import { useLayoutEffect, useRef } from 'react';

// Updates the height of a <textarea> when the value changes.
export const useAutosizeTextarea = (value: string) => {
	const textareaRef = useRef<HTMLTextAreaElement>(null);

	useLayoutEffect(() => {
		if (textareaRef.current != null) {
			// We need to reset the height momentarily to get the correct scrollHeight for the textarea
			textareaRef.current.style.height = '0px';
			const scrollHeight = textareaRef.current.scrollHeight;

			textareaRef.current.style.height = scrollHeight + 'px';
		}
	}, [textareaRef, value]);

	return textareaRef;
};
